import { h, FunctionComponent } from 'preact';
import { Trans } from '@lingui/macro';
import FullSite from './full-site';
import { TournamentLeaderboardContent } from '../desktop-pages/TournamentLeaderboardPage';

// Define props interface for the page component (to receive from router)
interface MobileTournamentLeaderboardPageProps {
    tournamentId: string; // Get tournamentId from router props
}

// Mobile page component for the Tournament Leaderboard.
// It uses the mobile FullSite wrapper, the shared content component,
// and passes the tournamentId prop down.
export const MobileTournamentLeaderboardPage: FunctionComponent<MobileTournamentLeaderboardPageProps> = (props) => {
    const { tournamentId } = props;

    return (
        <FullSite>
            <div class="p-4">
                <a href="/slot-tournaments" class="text-blue-400 hover:text-blue-300">
                    &larr; <Trans>Back to Tournaments List</Trans>
                </a>
            </div>

            <TournamentLeaderboardContent tournamentId={tournamentId} />
        </FullSite>
    );
};